// extracted by mini-css-extract-plugin
export default {"wrapper":"forms_wrapper__aFBYZ","buttonAction":"forms_buttonAction__tDXKs"};